import Logo from './Logo';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t-2 border-border mt-24 bg-card/50">
      <div className="container-ledger py-14 grid grid-cols-2 md:grid-cols-5 gap-8 text-sm">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <Logo />
            <span className="font-display uppercase">Key Receipt</span>
          </div>
          <p className="text-muted-foreground max-w-xs leading-relaxed">
            Per-client receipts for the AI line on your invoice. No token markup, ever.
          </p>
        </div>
        {[
          { title: 'Product', items: [['How it works', '#how'], ['Providers', '#providers'], ['Pricing', '#pricing']] },
          { title: 'Resources', items: [['Docs', '#'], ['Changelog', '#'], ['Status', '#']] },
          { title: 'Company', items: [['Privacy', '#'], ['Terms', '#'], ['Contact', 'mailto:hi@keyreceipt.com']] },
        ].map((col) => (
          <div key={col.title}>
            <div className="text-[10px] uppercase tracking-[0.18em] text-spray-magenta mb-3 font-bold">
              {col.title}
            </div>
            <ul className="space-y-2">
              {col.items.map(([label, href]) => (
                <li key={label}>
                  <a href={href} className="hover:text-spray-yellow text-muted-foreground transition-colors">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t-2 border-border">
        <div className="container-ledger py-5 text-[11px] uppercase tracking-wider text-muted-foreground flex flex-col sm:flex-row justify-between gap-2">
          <span>© {year} Key Receipt. Raw data, no markup.</span>
          <span className="font-mono">No. {year}-0001</span>
        </div>
      </div>
    </footer>
  );
}
